module.exports = __webpack_public_path__ + "img/splash-cropped-min-v2.defdb9d7.jpg";